import { Component, OnInit, AfterViewInit } from '@angular/core';
import { AuthService } from '../../services/auth/auth.service';
import { PendingTasksService } from 'src/app/services/pending-tasks/pending-tasks.service';
import { PendingTasksHandler } from 'src/app/shared/pending-tasks-handler';
import {TranslateService} from "@ngx-translate/core";

declare var $: any;

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css']
})
export class SidebarComponent implements OnInit {

  user_full_name: any="";
  user_language: any='en';
  public userPermissions: string[] = [];
  public isLoggedIn: boolean=false;
  noOfPendingEntries:number=0;
  noOfBlsPendingDOAndRadiationPmt:number=0;
  noOfUnpaidDuties:number=0;
  noOfPaymentsPendingReceiptsAttachment:number =0;
  noOfBlsPendingPortChargesPmt:number=0;
  noOfBlsPendingETAUpdatePmt:number=0;
  noOfCustomsPendingTasks:number=0;
  noOfDutyPendingTasks:number=0;
  noOfVehiclesPendingPhotoUpload:number=0;
  noOfVehiclesPendingDocsUpload:number=0;
  noOfVehiclesPendingPartsVerification:number=0;
  noOfVehiclesPendingUnbsCharges:number=0;
  noOfVehiclesPendingTollCharges:number=0;
  noOfVehiclesPendingForeignPermitPayment:number=0;
  noOfVehiclesPendingNumberPlatePayment:number=0;
  noOfVehiclesPendingKenyanInsurancePayment:number=0;
  noOfUnpaidUgDuties:number=0;
  isMobile = false;

  constructor(
    private authService: AuthService,
    private pendingTasksService: PendingTasksService,
    private pendingTasksHandler: PendingTasksHandler,
    private translate: TranslateService
    ) {
      this.user_language=localStorage.getItem('language');
      translate.setDefaultLang('en');
      translate.use(this.user_language);
     }

  ngOnInit(): void {
    this.user_full_name=localStorage.getItem('userFullName');
    this.userPermissions=this.authService.getPermissions();
    this.isLoggedIn = this.authService.isLoggedIn;
    this.isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent)

    // Subscribe to the count updates
    this.pendingTasksService.noOfPendingEntries$.subscribe((count) => {
      this.noOfPendingEntries = count;
    });

    this.pendingTasksService.noOfBlsPendingDOAndRadiationPmt$.subscribe((count) => {
      this.noOfBlsPendingDOAndRadiationPmt = count;
    });

    this.pendingTasksService.noOfUnpaidDuties$.subscribe((count) => {
      this.noOfUnpaidDuties = count;
    });

    this.pendingTasksService.noOfPaymentsPendingReceiptsAttachment$.subscribe((count) => {
      this.noOfPaymentsPendingReceiptsAttachment = count;
    });

    this.pendingTasksService.noOfBlsPendingPortChargesPmt$.subscribe((count) => {
      this.noOfBlsPendingPortChargesPmt = count;
    });

    this.pendingTasksService.noOfBlsPendingETAUpdatePmt$.subscribe((count) => {
      this.noOfBlsPendingETAUpdatePmt = count;
    });

    this.pendingTasksService.totalCustomsPendingTasks$.subscribe((noOfCustomsPendingTasks) => {
      this.noOfCustomsPendingTasks=noOfCustomsPendingTasks;
    });

    this.pendingTasksService.totalDutyPendingTasks$.subscribe((noOfDutyPendingTasks) => {
      this.noOfDutyPendingTasks=noOfDutyPendingTasks;
    });

    this.pendingTasksService.noOfVehiclesPendingPhotoUpload$.subscribe((count) => {
      this.noOfVehiclesPendingPhotoUpload = count;
    });

    this.pendingTasksService.noOfVehiclesPendingDocsUpload$.subscribe((count) => {
      this.noOfVehiclesPendingDocsUpload = count;
    });

    this.pendingTasksService.noOfVehiclesPendingPartsVerification$.subscribe((count) => {
      this.noOfVehiclesPendingPartsVerification = count;
    });

    this.pendingTasksService.noOfVehiclesPendingUnbsCharges$.subscribe((count) => {
      this.noOfVehiclesPendingUnbsCharges = count;
    });

    this.pendingTasksService.noOfVehiclesPendingTollCharges$.subscribe((count) => {
      this.noOfVehiclesPendingTollCharges = count;
    });

    this.pendingTasksService.noOfVehiclesPendingForeignPermitPayment$.subscribe((count) => {
      this.noOfVehiclesPendingForeignPermitPayment = count;
    });

    this.pendingTasksService.noOfVehiclesPendingNumberPlatePayment$.subscribe((count) => {
      this.noOfVehiclesPendingNumberPlatePayment = count;
    });

    this.pendingTasksService.noOfVehiclesPendingKenyanInsurancePayment$.subscribe((count) => {
      this.noOfVehiclesPendingKenyanInsurancePayment = count;
    });

    this.pendingTasksService.noOfUnpaidUgDuties$.subscribe((count) => {
      this.noOfUnpaidUgDuties = count;
    });

    //Count pending tasks
    if(this.userPermissions.includes('add-entry')){
      this.pendingTasksHandler.numberOfVehiclesPendingEntryInput();
    }

    if(this.userPermissions.includes('add-do-rad-pmt')){
      this.pendingTasksHandler.numberOfBLsPendingDOAndRadiationPmt();
    }

    if(this.userPermissions.includes('add-duty-pmt')){
      this.pendingTasksHandler.numberOfPendingDutyPayments();
    }

    if(this.userPermissions.includes('attach-duty-pmt-rcpt')){
      this.pendingTasksHandler.numberOfPaymentsPendingReceiptsAttachment();
    }

    if(this.userPermissions.includes('add-port-chgs')){
      this.pendingTasksHandler.numberOfBLsPendingPortChargesPmt();
    }

    if(this.userPermissions.includes('update-vsl-eta')){
      this.pendingTasksHandler.numberOfBLsPendingETAUpdatePmt();
    }

    if(this.userPermissions.includes('add-vhcl-photos')){
      this.pendingTasksHandler.numberOfVehiclesPendingPhotoUpload();
    }

    if(this.userPermissions.includes('add-imp-docs') || this.userPermissions.includes('add-vhcl-atts')){
      this.pendingTasksHandler.numberOfVehiclesPendingDocsUpload();
    }

    if(this.userPermissions.includes('ver-spare-parts')){
      this.pendingTasksHandler.numberOfVehiclesPendingPartsVerification();
    }

    if(this.userPermissions.includes('add-unbs-chg')){
      this.pendingTasksHandler.numberOfVehiclesPendingUnbsCharges();
    }

    if(this.userPermissions.includes('add-toll-chg')){
      this.pendingTasksHandler.numberOfVehiclesPendingTollCharges();
    }

    if(this.userPermissions.includes('add-fp-pmt')){
      this.pendingTasksHandler.numberOfVehiclesPendingForeignPermitPayment();
    }

    if(this.userPermissions.includes('add-np-pmt')){
      this.pendingTasksHandler.numberOfVehiclesPendingNumberPlatePayment();
    }

    if(this.userPermissions.includes('add-ke-ins-pmt')){
      this.pendingTasksHandler.numberOfVehiclesPendingKenyanInsurancePayment();
    }

    if(this.userPermissions.includes('add-ug-duty-pmt')){
      this.pendingTasksHandler.numberOfPendingUgDutyPayments();
    }
  }

  closeSidebar() {
    document.body.classList.remove('sidebar-open');
    document.body.classList.add('sidebar-collapse');
  }

 /**
 * Manually initializes AdminLTE's Treeview widget on the sidebar menu.
 *
 * AdminLTE's own auto-init runs once on page load and scans the DOM for
 * [data-widget="treeview"] elements at that exact moment. Since Angular
 * renders the sidebar asynchronously (and its *ngIf-gated menu items depend
 * on userPermissions resolving), AdminLTE's scan can run before the sidebar
 * DOM actually exists — especially as the app's JS bundle grows (e.g. after
 * adding Firebase), which delays Angular's bootstrap/render relative to
 * AdminLTE's script.
 *
 * When that race is lost, Treeview never binds, and clicking any parent
 * menu item silently does nothing (no console errors).
 *
 * The setTimeout(..., 0) defers this call to the next macrotask, ensuring
 * Angular's change detection has fully flushed and the sidebar's DOM is
 * in its final state before jQuery looks for elements to bind to.
 *
 * If userPermissions ever load asynchronously AFTER this component
 * initializes, this init call must also be re-run once permissions
 * resolve, or newly-rendered menu items still won't be interactive.
 *
 * Claude AI chat link: https://claude.ai/chat/74434729-a028-454f-acaf-97ea5d275b18
 */
  ngAfterViewInit(): void {
    setTimeout(() => {
      $('[data-widget="treeview"]').Treeview('init');
    }, 0);
  }
}
